import Sidebar from "@/components/common/Sidebar";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-900 to-slate-800">
      {/* Decorative background elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full blur-3xl bg-[#2EC4B6]/10"></div>
        <div className="absolute bottom-0 left-1/3 w-96 h-96 rounded-full blur-3xl bg-[#1B3A6B]/20"></div>
      </div>
      <Sidebar />
      <main className="ml-64 p-8 relative">
        <div className="max-w-7xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
